export default __webpack_public_path__ + "static/media/mentoriaOne.5ed02000.png";